<template>
  <div class="modal fade" id="transferResultsForStudentByUcoModalForm" tabindex="-1" aria-labelledby="transferResultsForStudentByUcoModalFormLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">    
        <div class="modal-header">
          <h5 class="modal-title" id="transferResultsForStudentByUcoModalFormLabel">Transmit results for specified students</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            <p>This action will transmit results of specified students and save them into IS MUNI PA036 block.</p>
            <p>It will overwrite all previous results in IS MUNI block.</p>
            <p>Transmitting results for specified students may take some time.</p>
          <hr>
          <div class="mb-3">
            <p>Check CSV of data that will be transmitted:</p>
            <button type="button" @click="generateAndShowCSVResultsForStudent" class="btn btn-primary btn-sm mx-1" :disabled="isGeneratingCSV || !studentUCOs">
              <span v-if="isGeneratingCSV" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span v-if="isGeneratingCSV">Generating CSV ...</span>
              <span v-else>View CSV</span>
            </button>
            <button type="button" @click="generateAndDownloadCSVForStudents" class="btn btn-success btn-sm mx-1" :disabled="isGeneratingCSV || !studentUCOs">
              <span v-if="isGeneratingCSV" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span v-if="isGeneratingCSV">Generating CSV ...</span>
              <span v-else>Download CSV</span>
            </button>
          </div>
          <hr>
          <form @submit.prevent="submitForm">
            <div class="mb-3">
              <label for="student_uco" class="form-label">Enter student UCOs separated by commas:</label>
              <input type="string" id="student_uco" class="form-control" v-model="studentUCOs" placeholder="123456,456789" required>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-primary" :disabled="!studentUCOs">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <StemErrorModal ref="stemErrorModal" />
</template>

<script>
import StemErrorModal from '@/components/StemErrorModal.vue';
import StudentController from '@/controllers/StudentController';

export default {
  name: 'TransferResultsForStudentByUcoModalForm',
  components: {
    StemErrorModal
  },
  data() {
    return {
      studentUCOs: null,
      isGeneratingCSV: false
    };
  },
  mounted() {
    // Reset = delete value from the form
    const modalElement = document.getElementById('transferResultsForStudentByUcoModalForm');
    modalElement.addEventListener('hidden.bs.modal', this.resetForm);
  },
  methods: {
    resetForm() {
      this.studentUCOs = null;
    },
    submitForm() {
      // Check if studentUCOs is not empty, is integer
      var listOfStudentUCOs = this.studentUCOs.split(',').map(uco => uco.trim());
      for (const uco of listOfStudentUCOs) {
        if (!uco || (uco && uco.trim() === '') || isNaN(uco)) {
          this.$refs.stemErrorModal.show('Error', 'Please enter a valid student UCO.');
          return;
        }
      }
      
      this.$emit('submitForm', this.studentUCOs);
    },
    async generateAndShowCSVResultsForStudent() {
      try {        
        this.isGeneratingCSV = true;
        var listOfStudentUCOs = this.studentUCOs.split(',').map(uco => uco.trim());
        if (listOfStudentUCOs.length === 0) {
          this.$refs.stemErrorModal.show('Error', 'Please enter at least one student UCO.');
          return;
        }
        const csvData = await StudentController.generateAndDownloadCSV(listOfStudentUCOs);
        // open file in new tab
        window.open(URL.createObjectURL(new Blob([csvData.data])));
      } catch (error) {
        this.$refs.stemErrorModal.show('Error', error.message);
      }
      finally {
        this.isGeneratingCSV = false;
      }
    },
    async generateAndDownloadCSVForStudents() {
      try {
        this.isGeneratingCSV = true;
        var listOfStudentUCOs = this.studentUCOs.split(',').map(uco => uco.trim());
        if (listOfStudentUCOs.length === 0) {
          this.$refs.stemErrorModal.show('Error', 'Please enter at least one student UCO.');
          return;
        }
        const csvData = await StudentController.generateAndDownloadCSV(listOfStudentUCOs);
        const url = window.URL.createObjectURL(new Blob([csvData.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', "transmitted_results.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.$refs.stemErrorModal.show('Error', error.message);
      }
      finally {
        this.isGeneratingCSV = false;
      }
    },
  }
};
</script>